export default __webpack_public_path__ + "static/media/tag-note.eddd891f.svg";